import {
  LuActivity, LuBot, LuCalendarDays, LuChartColumn, LuCirclePlus, LuCpu, LuFilter, LuFlame,
  LuKeyRound, LuLayoutGrid, LuLibrary, LuListChecks, LuPlay, LuRefreshCw, LuSave, LuSearch,
  LuServer, LuShield, LuSlidersHorizontal, LuUsersRound, LuWrench,
} from 'react-icons/lu';
import { moduleTour as tour, OPTIONAL as opt } from '../defineTour';

// Landing-tab tour first; one tour per further tab below it.
// /nexus/runs renders the same dashboard as /nexus, so the landing tour covers it.
const tours = [
  tour('nexus', '/nexus', 'nexus', [
    ['tabs', 'nexus.tabs', LuBot],
    ['studio', 'nexus.studio', LuLayoutGrid, { placement: 'top', ...opt }],
    ['trigger', 'nexus.trigger', LuPlay, { placement: 'left', ...opt }],
  ]),
  tour('nexus_agents', '/nexus/agents', 'nexus', [
    ['create', 'nexus_agents.create', LuCirclePlus],
    ['types', 'nexus_agents.types', LuFilter],
    ['search', 'nexus_agents.search', LuSearch],
  ], { exact: true }),
  tour('nexus_skills', '/nexus/skills', 'nexus', [
    ['library', 'nexus_skills.library', LuLibrary],
    ['search', 'nexus_skills.search', LuSearch],
    ['create', 'nexus_skills.create', LuCirclePlus],
  ], { exact: true }),
  tour('nexus_teams', '/nexus/teams', 'nexus', [
    ['new', 'nexus_teams.new', LuCirclePlus],
    ['list', 'nexus_teams.list', LuUsersRound, { placement: 'top' }],
  ], { exact: true }),
  tour('nexus_tools', '/nexus/tools', 'nexus', [
    ['create', 'nexus_tools.create', LuWrench],
    ['filters', 'nexus_tools.filters', LuFilter],
  ]),
  tour('nexus_mcp', '/nexus/mcp', 'nexus', [
    ['add', 'nexus_mcp.add', LuServer],
    ['servers', 'nexus_mcp.servers', LuLayoutGrid, { placement: 'top' }],
  ]),
  tour('nexus_vault', '/nexus/vault', 'nexus', [
    ['add', 'nexus_vault.add', LuKeyRound],
    ['search', 'nexus_vault.search', LuSearch],
  ]),
  tour('nexus_approvals', '/nexus/approvals', 'nexus', [
    ['queue', 'nexus_approvals.queue', LuListChecks, { placement: 'top' }],
    ['refresh', 'nexus_approvals.refresh', LuRefreshCw],
  ]),
  tour('nexus_observability', '/nexus/observability', 'nexus', [
    ['kpis', 'nexus_observability.kpis', LuActivity],
    ['period', 'nexus_observability.period', LuCalendarDays],
    ['volume', 'nexus_observability.volume', LuChartColumn, { placement: 'top' }],
  ]),
  tour('nexus_benchmark', '/nexus/benchmark', 'nexus', [
    ['setup', 'nexus_benchmark.setup', LuFlame, { placement: 'top' }],
    ['run', 'nexus_benchmark.run', LuPlay, { placement: 'top' }],
  ]),
  tour('nexus_settings', '/nexus/settings', 'nexus', [
    ['providers', 'nexus_settings.providers', LuCpu, { placement: 'top' }],
    ['add', 'nexus_settings.add', LuCirclePlus],
  ]),
  // Settings sub-tabs that switch in place (no URL change).
  tour('nexus_settings_defaults', null, 'nexus', [
    ['limits', 'nexus_settings_defaults.limits', LuSlidersHorizontal, { placement: 'top' }],
    ['save', 'nexus_settings_defaults.save', LuSave, { placement: 'top' }],
  ], { page: 'nexus_settings_defaults' }),
  tour('nexus_settings_governance', null, 'nexus', [
    ['gates', 'nexus_settings_governance.gates', LuShield, { placement: 'top' }],
    ['save', 'nexus_settings_governance.save', LuSave, { placement: 'top' }],
  ], { page: 'nexus_settings_governance' }),
  tour('nexus_settings_system', null, 'nexus', [
    ['tools', 'nexus_settings_system.tools', LuWrench, { placement: 'top' }],
    ['environment', 'nexus_settings_system.environment', LuServer, { placement: 'top' }],
  ], { page: 'nexus_settings_system' }),
];

export default tours;
